{
  "eyebrow": "法律資訊",
  "lastUpdated": "最後更新：{date}",
  "seeAlso": "另請參閱：",
  "linkTerms": "條款",
  "linkPrivacy": "私隱政策",
  "linkCookies": "Cookie 政策",
  "linkBuyerTerms": "買家條款",
  "linkSellerAgreement": "賣家協議",
  "linkRefunds": "退款與爭議",
  "terms": {
    "title": "條款及細則",
    "intro": "本條款及細則（「本條款」）構成閣下與BidNova Auctions Ltd（一間於England &amp; Wales註冊成立的公司，「我們」）之間具約束力的協議。閣下註冊、瀏覽、出價或於bidnovaauctions.uk（「平台」）上架物品，即表示同意本條款。",
    "s1.h": "1. 關於我們及本協議",
    "s1.p": "我們營運一個提供已評級及未評級卡牌（主要為Pokémon卡牌）拍賣的網上平台。我們僅作為買賣雙方之中介人，並非買賣合約的一方，惟我們會代賣家收取款項並暫時保管，直至交易完成為止。本條款受England &amp; Wales法律管轄，England &amp; Wales法院擁有專屬管轄權。",
    "s2.h": "2. 資格及帳戶註冊",
    "s2.li1": "閣下必須年滿18歲，並根據英國法律具有訂立合約的法律行為能力。",
    "s2.li2": "閣下必須提供準確的註冊資料，並保持資料更新。",
    "s2.li3": "閣下須對帳戶內的所有活動負責，並須為密碼保密。",
    "s2.li4": "閣下必須於註冊時接受本條款及我們的<a href=\"/legal/privacy\">私隱政策</a>。",
    "s2.li5": "我們可暫停或終止違反本條款、涉及欺詐或損害其他用戶的帳戶。",
    "s3.h": "3. 拍賣 — 出價運作方式",
    "s3.li1": "每個出價均為具法律約束力的購買要約，須按所出金額及任何底價（如有）進行。",
    "s3.li2": "出價一經作出，不得撤回。作出無力履行的出價即屬違反本條款。",
    "s3.li3": "出價須等於或高於目前出價加上拍賣品所示的最低加價幅度。",
    "s3.li4": "賣家可設定底價。如出價未達底價，則不會成立買賣合約。",
    "s3.li5": "為防止最後一刻「狙擊」出價，任何在最後兩分鐘作出的出價會將拍賣延長兩分鐘。",
    "s3.li6": "賣家不得直接或透過第三方就自己的拍賣出價（禁止「托價」）。",
    "s3.li7": "如中標出價達到底價，買賣雙方即成立具約束力的合約。",
    "s4.h": "4. 付款及平台費用",
    "s4.li1": "所有價格及費用均以英鎊（GBP，£）計算。",
    "s4.li2": "中標者須於72小時內透過我們的Stripe結帳系統完成付款。",
    "s4.li3": "我們代表賣家收取款項，並於送達確認前保管有關資金。",
    "s4.li4": "我們的平台佣金為中標金額的8%，於付款予賣家前扣除。並無上架費、月費或訂閱費用 — 佣金僅於成功售出時收取。",
    "s4.li5": "付款卡處理由Stripe Payments UK Ltd負責；閣下亦須同意Stripe的條款。",
    "s4.li6": "未能付款可能導致交易取消、帳戶負面評價及帳戶暫停。",
    "s5.h": "5. 送貨、追蹤及買家確認",
    "s5.li1": "賣家須於付款確認後5個工作日內寄出貨品並上載追蹤編號。",
    "s5.li2": "所有英國境內寄送須使用具追蹤及簽收服務（例如Royal Mail Special Delivery）。",
    "s5.li3": "買家於收到及檢查貨品後，應透過平台確認收貨。",
    "s5.li4": "如送達後72小時內未提出爭議，該訂單將自動被視為已接受。",
    "s6.h": "6. 買家保障",
    "s6.p": "由於閣下向個人或商業賣家購買，Consumer Rights Act 2015下的法定權利僅於賣家屬商業交易者時適用。此外，我們為每宗購買提供以下平台保障：",
    "s6.li1": "付款透過 Stripe 安全處理。賣家款項將按照 BidNova Auctions 的付款政策發放。",
    "s6.li2": "如物品與描述不符、已損壞或未有送達，閣下可提出爭議。",
    "s6.li3": "如管理員裁定爭議對閣下有利，我們將向閣下退款，並向賣家追討有關款項。",
    "s6.li4": "有關PSA、BGS或CGC評級盒的評級爭議，將參考評級公司的紀錄解決。",
    "s7.h": "7. 賣家義務（摘要）",
    "s7.p": "完整的賣家義務載於<a href=\"/legal/seller-agreement\">賣家協議</a>。簡言之，賣家須準確描述每件拍賣品、披露瑕疵、對物品擁有完整所有權、迅速寄出貨品，並遵守英國消費者及稅務法例。",
    "s8.h": "8. 禁止物品及行為",
    "s8.p1": "以下物品不得於平台上架、出售或宣傳：",
    "s8.li1": "偽造、造假或複製卡牌、被改裝的評級盒，或評級標籤遭竄改的物品。",
    "s8.li2": "贓物或閣下無權出售的物品。",
    "s8.li3": "侵犯The Pokémon Company、Nintendo或任何第三方知識產權的物品。",
    "s8.li4": "受英國出口管制或貿易制裁限制的物品。",
    "s8.li5": "武器、毒品、成人內容或任何根據英國法律屬非法的物品。",
    "s8.p2": "閣下亦不得：操縱出價、騷擾其他用戶、抓取平台資料，或試圖規避費用。",
    "s9.h": "9. 爭議及解決",
    "s9.li1": "買家或賣家可透過訂單頁面以書面描述問題，提出爭議。",
    "s9.li2": "在訂單存在活躍爭議期間，不會向賣家發放任何款項。",
    "s9.li3": "我們的管理團隊會審核證據並與雙方溝通，然後才作出裁決。",
    "s9.li4": "可能的解決方案包括退款、向賣家發放款項或部分和解。",
    "s9.li5": "閣下仍保留透過England &amp; Wales法院尋求法定補救的權利。",
    "s10.h": "10. 費用、稅項及發票",
    "s10.p": "賣家須自行負責其稅務事宜，包括任何增值稅義務及向HMRC申報收入。根據OECD數碼平台申報規則模型，HMRC可能要求我們分享交易資料。",
    "s11.h": "11. 知識產權",
    "s11.p": "平台（包括品牌、設計及程式碼）由我們或我們的授權方擁有。未經我們書面同意，閣下不得複製、轉售或對平台任何部分進行逆向工程。",
    "s12.h": "12. 責任限制",
    "s12.p": "本條款並不限制因疏忽導致死亡或人身傷害、欺詐，或任何根據英國法律不可限制的責任。除此之外，我們就平台所承擔的整體責任，上限為£100或閣下於索償事件發生前12個月內向我們支付的費用總額，以兩者中較高者為準。",
    "s13.h": "13. 本條款的修訂",
    "s13.p": "我們可能不時更新本條款。重大變更將於生效前最少14天以電郵或平台通知方式告知閣下。閣下於生效日期後繼續使用平台，即視為接受有關變更。",
    "s14.h": "14. 聯絡方式",
    "s14.p": "如對本條款有任何疑問：<a href=\"mailto:legal@bidnovaauctions.uk\">legal@bidnovaauctions.uk</a>。"
  },
  "privacy": {
    "title": "私隱政策",
    "intro": "BidNova Auctions Ltd（「我們」）為閣下於使用bidnovaauctions.uk（「平台」）時所提供個人資料的資料控制者。我們按照UK GDPR、Data Protection Act 2018及Privacy and Electronic Communications Regulations（PECR）處理個人資料。",
    "s1.h": "1. 我們收集的資料",
    "s1.li1": "<strong>帳戶資料：</strong>姓名、電郵地址、密碼（經雜湊處理）、顯示名稱、頭像。",
    "s1.li2": "<strong>驗證資料：</strong>就較高交易額的賣家而言，包括身份證明文件及地址確認。",
    "s1.li3": "<strong>交易資料：</strong>出價、購買、銷售、訂單紀錄、追蹤編號、送達確認、爭議紀錄。",
    "s1.li4": "<strong>付款資料：</strong>由Stripe Payments UK Ltd處理；我們僅收到元資料（卡號後4位、卡種、國家），絕不會取得完整卡資料。",
    "s1.li5": "<strong>技術資料：</strong>IP地址、裝置／瀏覽器資料、時間戳記、會話cookie（詳見我們的<a href=\"/legal/cookies\">Cookie政策</a>）。",
    "s1.li6": "<strong>通訊紀錄：</strong>閣下透過平台向我們或其他用戶發送的訊息。",
    "s2.h": "2. 我們如何使用閣下的資料及相關法律依據",
    "s2.li1": "<strong>提供平台服務</strong>（第6(1)(b)條 — 履行合約）：帳戶管理、出價、訂單履行、付款、款項發放、爭議處理。",
    "s2.li2": "<strong>防止欺詐及平台安全</strong>（第6(1)(f)條 — 合法利益）：偵測托價、偽造上架物品、欺詐性拒付。",
    "s2.li3": "<strong>法律及稅務合規</strong>（第6(1)(c)條）：反洗錢審查、HMRC數碼平台申報、法院／ICO命令。",
    "s2.li4": "<strong>服務通訊</strong>（合約）：拍賣結果、付款收據、爭議更新、安全警示。",
    "s2.li5": "<strong>市場推廣</strong>（第6(1)(a)條 — 同意）：推廣電郵；閣下可隨時取消訂閱。",
    "s3.h": "3. 我們與哪些對象分享資料",
    "s3.li1": "已完成交易的買賣雙方（僅限於送貨所需資料）。",
    "s3.li2": "我們的付款處理商Stripe Payments UK Ltd。",
    "s3.li3": "作為我們的資料處理者的雲端基礎設施及電郵服務供應商。",
    "s3.li4": "HMRC及其他依法有權要求資料的機關。",
    "s3.li5": "以保密方式提供服務的專業顧問。",
    "s3.p": "我們絕不會出售閣下的個人資料。",
    "s4.h": "4. 跨境資料轉移",
    "s4.p": "如個人資料需轉移至英國境外，我們會依據UK International Data Transfer Agreement（IDTA）、UK Addendum to the EU Standard Contractual Clauses，或適用的充分性認定條例。",
    "s5.h": "5. 資料保留",
    "s5.li1": "帳戶資料：於帳戶生效期間保留，並於帳戶關閉後為稅務及法律紀錄目的再保留6年。",
    "s5.li2": "交易及付款紀錄：按英國稅法規定保留6年。",
    "s5.li3": "市場推廣偏好：直至閣下撤回同意為止。",
    "s5.li4": "爭議證據：由解決之日起保留6年。",
    "s5.li5": "廣告分析：個別橫額展示及點擊紀錄會經匿名化處理（我們僅儲存單向雜湊值，絕不儲存閣下原始IP地址），並於90天後自動刪除。此後僅保留匿名每日總計數字 — 展示次數、點擊次數及獨立訪客人數 — 供廣告主報告之用。廣告分析僅於閣下接受分析cookie後才會收集，我們亦可應要求刪除某廣告活動的原始分析資料。",
    "s6.h": "6. 閣下於UK GDPR下的權利",
    "s6.li1": "查閱權 — 要求索取我們持有關於閣下的個人資料副本。",
    "s6.li2": "更正權 — 要求我們更正不準確的資料。",
    "s6.li3": "刪除權 — 要求我們刪除閣下的資料（惟須受法定保留義務所限）。",
    "s6.li4": "限制及反對權 — 限制或反對特定的資料處理。",
    "s6.li5": "可攜權 — 以結構化、機器可讀格式取得閣下的資料。",
    "s6.li6": "隨時撤回同意（不影響先前已合法進行的處理）。",
    "s6.li7": "向英國Information Commissioner's Office（ICO）投訴 — <a href=\"https://ico.org.uk\" target=\"_blank\" rel=\"noreferrer\">ico.org.uk</a>。",
    "s6.p": "如欲行使有關權利，請電郵至<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>。我們將於一個月內回覆。",
    "s7.h": "7. 保安",
    "s7.p": "我們對所有流量使用TLS加密，以現代雜湊技術加密密碼，實施存取控制，並監察可疑活動。惟沒有系統能做到絕對安全 — 如我們發現有可能對閣下權利構成風險的個人資料外洩事故，我們將於72小時內通知ICO，並於有需要時通知閣下。",
    "s8.h": "8. 兒童",
    "s8.p": "本平台並非供18歲以下人士使用，我們亦不會蓄意收集兒童的資料。",
    "s9.h": "9. 修訂",
    "s9.p": "如本政策有重大修訂，我們將以電郵或平台通知方式告知閣下。",
    "s10.h": "10. 聯絡方式",
    "s10.p": "資料控制者：BidNova Auctions Ltd，於England &amp; Wales註冊成立。聯絡方式：<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>。"
  },
  "cookies": {
    "title": "Cookie政策",
    "intro": "本Cookie政策說明BidNova Auctions Ltd如何於bidnovaauctions.uk使用cookie及類似技術。本政策應與我們的<a href=\"/legal/privacy\">私隱政策</a>一併閱讀。Cookie於英國受Privacy and Electronic Communications Regulations（PECR）及UK GDPR規管。",
    "s1.h": "1. 甚麼是cookie？",
    "s1.p": "Cookie是閣下瀏覽網站時放置於裝置上的小型文字檔案。Cookie讓網站能於一段時間內記住閣下的操作及偏好（例如維持登入狀態）。",
    "s2.h": "2. 我們使用的cookie",
    "s2.h3a": "絕對必要（毋須徵得同意）",
    "s2.li1a": "<strong>會話及登入驗證：</strong>維持閣下的登入狀態並保障會話安全。",
    "s2.li2a": "<strong>安全令牌：</strong>防範CSRF攻擊及濫用行為。",
    "s2.li3a": "<strong>負載平衡：</strong>將閣下的請求路由至正確的伺服器。",
    "s2.h3b": "功能性（僅於啟用時使用）",
    "s2.li1b": "<strong>偏好設定：</strong>記住主題等顯示設定。",
    "s2.li2b": "<strong>追蹤清單狀態：</strong>記住閣下於不同瀏覽間所追蹤的拍賣品。",
    "s2.h3c": "分析（須選擇加入）",
    "s2.li1c": "有助我們改善平台的匯總、注重私隱的分析數據。",
    "s2.li2c": "此類cookie僅於閣下透過我們的cookie橫幅同意後才會設置。",
    "s2.h3d": "第三方cookie",
    "s2.li1d": "<strong>Stripe：</strong>於結帳頁面進行防詐騙偵測（就付款而言屬絕對必要）。",
    "s2.li2d": "<strong>Google（如適用）：</strong>僅於閣下選擇以「使用Google繼續」登入時使用。",
    "s3.h": "3. 閣下的選擇",
    "s3.li1": "閣下可透過我們的cookie橫幅接受或拒絕非必要cookie。",
    "s3.li2": "閣下可透過瀏覽器設定清除或封鎖cookie；惟絕對必要cookie如遭停用，將導致核心功能（如出價、結帳）無法運作。",
    "s3.li3": "閣下可隨時透過清除網站資料並重新造訪以更改偏好設定。",
    "s4.h": "4. Do Not Track（請勿追蹤）",
    "s4.p": "由於「Do Not Track」訊號並無一致的業界標準，我們的平台目前並不會對其作出回應。",
    "s5.h": "5. 修訂",
    "s5.p": "當我們更改使用cookie的方式時，將會更新本政策，敬請定期查閱。",
    "s6.h": "6. 聯絡方式",
    "s6.p": "如有疑問，請電郵至<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>。"
  }
}
